import { forwardRef, useImperativeHandle, useState } from "react";
import PropTypes from "prop-types";

const BackButton = forwardRef(({ clickHandler }, ref) => {
    const [showBackButton, setShowBackButton] = useState(false);

    useImperativeHandle(ref, () => ({
        showHideBackButton(show) {
            setShowBackButton(show);
        },
    }));

    return (
        showBackButton && (
            <div className='topbar-button'>
                <div className='button'>
                    <button className='btn topbar-btn' onClick={() => clickHandler()}>
                        <span className='for-icon icon-previous'></span>
                    </button>
                </div>
            </div>
        )
    );
});

BackButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
};

export default BackButton;
